import { createDrawerContext } from '@/contexts/drawer-context';
import { type FC, type ReactNode } from 'react';
import { OrderInboundsOrderListDrawerContent } from './order-inbounds-order-list-drawer-content';

const { DrawerContextProvider, useDrawerContext, useMaybeDrawerContext } =
  createDrawerContext({
    ContentComponent: OrderInboundsOrderListDrawerContent,
    drawerStyle: {
      boxShadow: '0 12px 24px 0 rgba(0, 0, 0, 0.08)',
    },
    overlayStyle: {
      backgroundColor: 'transparent',
    },
    position: 'left',
    width: 294,
  });

export const useOrderInboundsOrderListDrawerContext = useDrawerContext;

export const useOrderInboundsOrderListDrawerMaybeContext =
  useMaybeDrawerContext;

interface OrderInboundsOrderListDrawerProviderProps {
  children?: ReactNode;
}

export const OrderInboundsOrderListDrawerProvider: FC<
  OrderInboundsOrderListDrawerProviderProps
> = ({ children }) => {
  return <DrawerContextProvider>{children}</DrawerContextProvider>;
};
